import { render } from "./WidgetEditorCmp.vue?vue&type=template&id=3f587397"
import script from "./WidgetEditorCmp.vue?vue&type=script&lang=js"
export * from "./WidgetEditorCmp.vue?vue&type=script&lang=js"

import "./WidgetEditorCmp.vue?vue&type=style&index=0&id=3f587397&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__